import styled from 'styled-components';

export const Container = styled.div`
  width: calc(100% - 6rem);
  margin-left: 6rem;
  height: calc(100vh - 7rem);
  /* display: flex; */
  overflow-y: scroll;
  background: var(--background-content);
  @media (max-width: 600px) {
    width: 100%;
    margin: 0;
    height: calc(100vh - 4rem);
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;
